import { getFunctions, httpsCallable } from "firebase/functions";
import { REGION } from "store/ref";
import { PROJECT_ID } from "config/keys/user";
import { getApp } from "firebase/app";

const app = getApp(PROJECT_ID);
const functions = getFunctions(app, REGION);

// get functions api.
export const getApiFunctions = () => {
  // :::::::::::: LOGIN :::::::::::::://

  // login operator.
  const login = httpsCallable(functions, "api-operator-login-token");

  // generate token for bailiff.
  const generateToken = httpsCallable(
    functions,
    "api-login-bailiff-token-generate",
  );

  // hàm add pin code.
  const emailSendCode = httpsCallable(
    functions,
    "api-email-verification-add-pincode",
  ); // { email, source },
  const emailCheckCode = httpsCallable(
    functions,
    "api-email-verification-check-pincode",
  ); // { email, source, pincode},

  // update account
  const updateDisplayName = httpsCallable(functions, "api-user-update-info"); // {displayName}
  const updateAvatar = httpsCallable(functions, "api-upload-avatar-file-url"); // {contentType}

  // CLIENT ĐỔI RESELLER.
  const switchReseller = httpsCallable(functions, "api-client-switch-reseller"); // {id}

  // return.
  return {
    login,
    email: {
      emailSendCode,
      emailCheckCode,
    },
    account: {
      //
      updateDisplayName,
      updateAvatar,
    },
    client: {
      switchReseller,
    },
    generateToken,
  };
};
